import React, { useCallback, useEffect, useState } from "react";
import SetupCard from "../../components/Setup/SetupCard";
import { getSetupProposals } from "../../api/setupApi";
import "../../components/Setup/SetupCard.css";

/* The Setup screen — the durable home behind the dashboard banner and the
   point-of-bite cards. Lists every inferred-but-unconfirmed proposal for this
   tenant. Each card is confirmed independently; when the last one is confirmed
   the page shows the all-set state. Nothing here writes until the owner
   confirms a card. */
export default function SetupPage() {
  const [loading, setLoading] = useState(true);
  const [proposals, setProposals] = useState([]);
  const [confirmedFields, setConfirmedFields] = useState(() => new Set());

  const load = useCallback(() => {
    setLoading(true);
    getSetupProposals()
      .then((d) => setProposals(Array.isArray(d?.proposals) ? d.proposals : []))
      .catch(() => setProposals([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const onConfirmed = (field) => {
    setConfirmedFields((prev) => new Set(prev).add(field));
  };

  const remaining = proposals.filter((p) => !confirmedFields.has(p.field));

  return (
    <div className="setup-page">
      <h1 className="setup-page__h1">Finish setup</h1>
      <p className="setup-page__lede">
        We looked at your history and inferred a few things that aren't set up yet. Review each,
        correct anything that's off, and confirm. Nothing is saved until you press Confirm — and
        what you confirm is exactly what you see here.
      </p>

      {loading && <div className="setup-page__empty">Loading…</div>}

      {!loading && remaining.length === 0 && (
        <div className="setup-page__empty">
          <b>You're all set.</b>
          <div style={{ marginTop: 6 }}>There's nothing left to confirm right now.</div>
        </div>
      )}

      {!loading &&
        remaining.map((p) => (
          <SetupCard key={p.field} proposal={p} onConfirmed={onConfirmed} />
        ))}
    </div>
  );
}
